import React from "react";
import LegalPage, { useLegalInfo, Val, MissingFieldsBlock } from "./LegalPage";

export default function CookiesPolicy() {
  const info = useLegalInfo();
  return (
    <LegalPage overline="Document légal" title="Politique des témoins (cookies)">
      <p><strong>Effective :</strong> <Val info={info} k="PRIVACY_POLICY_EFFECTIVE_DATE" /></p>

      <h2>1. Ce qui est réellement installé sur la plateforme</h2>
      <p>
        À la date de rédaction, la plateforme Le Révélateur™ n'installe <strong>aucun traceur publicitaire
        non essentiel</strong>. Il n'y a pas de Meta Pixel, pas de Google Analytics, pas de TikTok Pixel,
        pas de LinkedIn Insight Tag ni d'outil équivalent d'analytique ou de reciblage.
      </p>
      <p>
        Cette absence a été vérifiée dans le code source de l'application. Toute mise à jour future
        introduisant un tel outil sera signalée dans cette page et déclenchera l'affichage d'une bannière
        de consentement conforme.
      </p>

      <h2>2. Catégories de témoins</h2>
      <p>Par transparence, voici les catégories habituellement utilisées sur les sites en ligne :</p>
      <ul>
        <li><strong>Témoins strictement nécessaires</strong> — indispensables au fonctionnement (session, sécurité, paiement).</li>
        <li><strong>Témoins de préférences</strong> — enregistrent des choix comme la langue ou l'affichage.</li>
        <li><strong>Témoins d'analytique</strong> — mesurent l'audience et l'usage.</li>
        <li><strong>Témoins publicitaires ou de reciblage</strong> — profilage marketing.</li>
      </ul>

      <h2>3. Ce que Le Révélateur™ utilise réellement</h2>
      <ul>
        <li>
          <strong>Témoins strictement nécessaires uniquement.</strong> Ils permettent le maintien de la session
          d'un questionnaire en cours, l'authentification technique du lien privé de votre rapport, et la
          finalisation du paiement Stripe.
        </li>
        <li>
          <strong>Aucun témoin d'analytique</strong> n'est déposé par nos soins à ce jour.
        </li>
        <li>
          <strong>Aucun témoin publicitaire ou de reciblage</strong> n'est déposé à ce jour.
        </li>
      </ul>

      <h2>4. Bannière de consentement</h2>
      <p>
        Comme aucun script non essentiel n'est présent, aucune bannière de consentement n'est affichée. Cela
        respecte le principe selon lequel un consentement n'est requis que pour les traceurs non essentiels.
      </p>
      <p>
        Si des outils d'analytique ou de reciblage sont ajoutés dans le futur, une bannière proposant
        <em> Accepter</em>, <em>Refuser les témoins non essentiels</em> et <em>Personnaliser</em> sera mise en
        place, et aucun script non essentiel ne sera chargé avant votre choix. Un lien permanent
        « Gérer mes préférences » sera alors ajouté au bas de page.
      </p>

      <h2>5. Fournisseurs susceptibles de déposer un témoin technique</h2>
      <p>
        Lors du paiement, Stripe peut déposer des témoins strictement nécessaires à la sécurité et à la
        finalisation de la transaction, sur les pages qu'il contrôle. Ces témoins échappent au contrôle de
        Maison Beaudette™ et sont couverts par les politiques propres à Stripe.
      </p>

      <h2>6. Vos droits</h2>
      <p>
        Vous pouvez à tout moment configurer votre navigateur pour bloquer ou effacer les témoins. Bloquer
        certains témoins strictement nécessaires peut empêcher le bon fonctionnement du service (par exemple,
        la finalisation d'un paiement).
      </p>

      <h2>7. Contact</h2>
      <p>
        Courriel : <Val info={info} k="SUPPORT_EMAIL" /><br />
        Vie privée : <Val info={info} k="PRIVACY_EMAIL" />
      </p>

      <MissingFieldsBlock info={info} />
    </LegalPage>
  );
}
